<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/pegawai-list-custom">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Diklat
        </li>
      </ol>
    </nav>

    <div class="content-block">
      <h5>Daftar Diklat</h5>
    </div>
    <LogPopupTemplate ref="logPopup" />
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxPopupAsPopup
          :visible="loadingVisible"
          title="Loading data pegawai dan jabatan"
          :drag-enabled="false"
          :hide-on-outside-click="false"
          width="300"
          :height="130"
        >
          <div class="d-flex justify-content-center">
            <div
              class="spinner-border"
              style="width: 3rem; height: 3rem"
              role="status"
            ></div>
          </div>
        </DxPopupAsPopup>

        <DxDataGrid
          ref="dataGrid"
          :data-source="diklatListStore.dataSourceDiklatList"
          :remote-operations="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :focused-row-enabled="true"
          :filter-sync-enabled="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
          :height="gridHeight"
          :word-wrap-enabled="true"
          @editor-preparing="oneditorpreparing"
          @editing-start="onEditingStart"
          @exporting="onExporting"
          @row-inserting="onInsertingDiklat"
          @row-updating="onUpdatingDiklat"
          @initNewRow="onInitNewRow"
        >
          <DxSorting mode="multiple" />

          <DxHeaderFilter :visible="true" />
          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxEditing
            :allow-updating="allowUpdating"
            :allow-deleting="allowDeleting"
            :allow-adding="allowAdding"
            mode="popup"
          >
            <DxPopup :show-title="true" title="Data Diklat" />
            <!-- :width="700"
            :height="525" -->
            <DxFormDataGrid :form-data="formData" ref="formInstance">
              <DxItem :col-count="2" :col-span="2" item-type="group">
                <DxItem
                  data-field="tgl"
                  :editor-options="{
                    onValueChanged: onTglValueChanged,
                  }"
                />
                <DxItem data-field="penyelenggara" />
                <DxItem data-field="jml_peserta" />
                <DxItem data-field="sertifikat" />

                <!-- <DxItem
                  data-field="biaya"
                  :editor-options="{
                    format: {
                      formatter: (value) =>
                        value == null
                          ? ''
                          : new Intl.NumberFormat('id-ID').format(value),
                      parser: (value) =>
                        parseInt(value.replace(/\./g, '').replace(/,/g, '')) ||
                        0,
                    },
                    showClearButton: true,
                  }"
                /> -->

                <!-- -->
                <DxItem
                  data-field="biaya"
                  :editor-options="
                    commonFunction.editorOptionsFormatterSeparateTypingWithDots
                  "
                />

                <DxItem data-field="materi" />
              </DxItem>
              <DxItem :col-span="2">
                <span><strong>Daftar Peserta</strong></span>
                <DxDataGrid
                  ref="dataGridPeserta"
                  :data-source="pesertaDataSource"
                  :focused-row-index="0"
                  :show-borders="true"
                  :show-column-lines="false"
                  :focused-row-enabled="true"
                  :column-auto-width="true"
                  :column-hiding-enabled="false"
                  :allow-column-reordering="true"
                  key-expr="id"
                  @editor-preparing="oneditorpreparing"
                  @saved="onSavedPeserta"
                  @initNewRow="onInitNewRowPegawai"
                >
                  <dx-paging :page-size="10" />
                  <dx-pager :show-page-size-selector="true" :show-info="true" />
                  <dx-filter-row :visible="true" />
                  <DxExport
                    :enabled="true"
                    :allow-export-selected-data="true"
                  />
                  <!-- <DxSelection :mode="multiple" :showCheckBoxesMode="always" /> -->

                  <DxToolbar>
                    <DxItem name="groupPanel" />

                    <DxItem name="addRowButton" show-text="always" />
                    <DxItem name="exportButton" />
                    <DxItem name="columnChooserButton" />
                    <DxItem name="searchPanel" />
                  </DxToolbar>

                  <DxEditing
                    :allow-updating="allowAddingPegawai"
                    :allow-adding="allowAddingPegawai"
                    :allow-deleting="allowAddingPegawai"
                    mode="row"
                    :new-row-position="bottom"
                  />
                  <DxSorting mode="multiple" />

                  <DxColumn
                    class="noteditable"
                    caption="pegawai_id"
                    data-field="pegawai_id"
                    :allow-filtering="false"
                    :allow-sorting="false"
                    :allow-exporting="false"
                    :visible="false"
                  />

                  <DxColumn caption="Nama Pegawai" data-field="nama">
                    <DxLookup
                      value-expr="id"
                      :display-expr="
                        (item) => {
                          if (!item) return '';
                          if (item.nik) return `${item.nik} - ${item.nama}`;
                          return `- ${item.nama}`;
                        }
                      "
                      :data-source="pegawaiSource"
                    />
                  </DxColumn>

                  <DxColumn
                    class="noteditable"
                    caption="Jabatan"
                    data-field="jabatan_print"
                  />
                  <DxColumn
                    class="noteditable"
                    caption="riwayatpekerjaansid"
                    data-field="riwayat_pekerjaans_id"
                    :visible="false"
                  />
                  <DxSummary>
                    <DxTotalItem
                      column="nik"
                      summary-type="count"
                      value-format="#,##0"
                    />
                  </DxSummary>
                </DxDataGrid>
              </DxItem>
            </DxFormDataGrid>
          </DxEditing>
          <DxPaging :page-size="15" />
          <DxPager :visible="true" />
          <DxExport :enabled="true" />
          <DxToolbar>
            <DxItem location="before">
              <DxTextBox
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                label="Cari Nama Peserta"
                placeholder="Nama Peserta"
                :value="diklatListModel.pegawaiFilter"
                @valueChanged="diklatListStore.onPegawaiChanged"
              />
              <!-- -->
            </DxItem>

            <DxItem location="after" v-if="can('pegawai-create')">
              <DxButton
                icon="print"
                @click="printBpkp('dataGrid')"
                text="Print"
                type="default"
                style="float: left"
                width="150px"
                styling-mode="filled"
              ></DxButton>
            </DxItem>
            <DxItem location="after" v-if="can('pegawai-create')">
              <DxButton
                icon="exportxlsx"
                @click="exportBpkp('dataGrid')"
                text="Export"
                type="default"
                style="float: left"
                width="150px"
                styling-mode="filled"
              ></DxButton>
            </DxItem>
            <DxItem location="after">
              <DxButton
                icon="refresh"
                @click="refreshDatagrid('dataGrid')"
                text="Refresh Data"
                type="default"
                style="float: left"
                width="160px"
                styling-mode="outlined"
              ></DxButton>
            </DxItem>
            <DxItem name="groupPanel" />
            <DxItem
              name="addRowButton"
              show-text="always"
              v-if="can('pegawai-create')"
            />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
          </DxToolbar>
          <template #refresh-template> </template>

          <!-- <DxSearchPanel :visible="true" highlight-case-sensitive="false" /> -->

          <DxColumn
            class="noteditable"
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            data-type="number"
          />
          <!-- <DxColumn
            :allowHeaderFiltering="false"
            data-field="tahun"
            caption="Tahun"
            data-type="date"
            :display-format="'yyyy'"
            :format="'yyyy'"
            cell-template="tahunTemplate"
            :filter-operations="filterOperations"
          >
          </DxColumn> -->
          <DxColumn
            :allowHeaderFiltering="false"
            data-field="bulan"
            caption="Bulan"
            data-type="date"
            :display-format="'MM/yyyy'"
            :format="'MM/yyyy'"
            :customize-text="commonFunction.formatIsoDateToMonthYear"
            :filter-operations="filterOperations"
            :calculate-filter-expression="calculateFilterExpressionBulan"
          >
          </DxColumn>

          <template #tahunTemplate="{ data }">
            {{ commonFunction.formatDateToYear(data.text) }}
          </template>

          <DxColumn
            :allowHeaderFiltering="false"
            data-type="date"
            data-field="tgl"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          >
            <DxRequiredRule />
          </DxColumn>
          <DxColumn
            data-field="penyelenggara"
            :allowHeaderFiltering="false"
            caption="Penyeleggara Diklat/Narasumber Diklat (Lembaga)"
          >
            <DxRequiredRule />
          </DxColumn>
          <DxColumn
            class="noteditable"
            data-field="jml_peserta"
            :allowHeaderFiltering="false"
            caption="Jumlah Peserta"
          />

          <DxColumn
            :allow-filtering="false"
            data-field="sertifikat"
            :dataType="'boolean'"
            :show-editor-always="false"
            :customize-text="commonFunction.appendAdaTidak"
            :allowHeaderFiltering="true"
            caption="Ada atau Tidak Sertifikat"
            :header-filter="{ dataSource: commonStore.statusSertifikatSource }"
          >
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="commonStore.statusSertifikatStore"
            />
          </DxColumn>

          <DxColumn
            data-type="number"
            data-field="biaya"
            :customize-text="commonFunction.formatNumberWithDots"
            :allowHeaderFiltering="false"
            caption="Biaya Diklat"
          >
            <DxRequiredRule />
          </DxColumn>

          <DxColumn
            data-field="materi"
            :allowHeaderFiltering="false"
            caption="Materi Diklat"
          >
            <DxRequiredRule />
          </DxColumn>

          <DxColumn
            data-field="dummy"
            :allowHeaderFiltering="false"
            caption="dummy"
            :visible="false"
          >
          </DxColumn>
          <DxColumn
            caption="Dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxMasterDetail :enabled="true" template="master-detail" />
          <template #master-detail="{ data }">
            <MasterDetailDiklat
              :detail="data.data.diklat_pegawais"
              :info="data.data.penyelenggara"
            />
          </template>
          <DxSummary>
            <DxTotalItem
              column="biaya"
              summary-type="sum"
              value-format="#,##0"
            />
          </DxSummary>
          <DxColumn type="buttons" :width="110">
            <DxButtonDataGrid name="edit" />
            <DxButtonDataGrid name="delete" />
            <DxButtonDataGrid
              hint="View Log Perubahan"
              icon="clock"
              :visible="true"
              @click="this.$refs.logPopup.showBySubject($event, 'Diklat')"
            />
          </DxColumn>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import notify from "devextreme/ui/notify";
import auth from "@/auth";
import { ref } from "vue";
import { reactive } from "vue";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import { DateTime } from "luxon";
import * as XLSX from "xlsx";
import * as commonFunction from "@/utils/common-function.js";
import { BASE_URL } from "@/global-constants";
import { useDiklatListStore } from "@/stores/views/diklat-list-store";
import { usePegawaiListStore } from "@/stores/views/pegawai-list-store";
import { useDiklatListModel } from "@/stores/models/diklat-list-model";
import { useCommonStore } from "@/stores/utility/common-store2";
import can from "@/haspermission";
import _ from "lodash";
import DataSource from "devextreme/data/data_source";
import { DxPopup as DxPopupAsPopup } from "devextreme-vue/popup";
import {
  DxMasterDetail,
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
  DxPopup,
  DxForm as DxFormDataGrid,
  DxRequiredRule,
  DxSorting,
  DxButton as DxButtonDataGrid,
} from "devextreme-vue/data-grid";

import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import MasterDetailDiklat from "./MasterDetailDiklat.vue";
import DxButton from "devextreme-vue/button";
import { useDukListStore } from "@/stores/views/duk-list-store";
// import { custom } from "devextreme/ui/dialog";

export default {
  components: {
    DxPopupAsPopup,
    DxFormDataGrid,
    DxButton,
    DxMasterDetail,
    DxTextBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    // DxSelection,
    DxExport,
    DxToolbar,

    DxPopup,

    DxItem,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    MasterDetailDiklat,
    DxRequiredRule,
    DxSorting,
    DxButtonDataGrid,
    LogPopupTemplate,
  },
  setup() {
    const diklatListStore = useDiklatListStore();
    const pegawaiListStore = usePegawaiListStore();
    const diklatListModel = useDiklatListModel();
    const dukListStore = useDukListStore();

    const commonStore = useCommonStore();
    const jmlPeserta = ref(0);
    const resetJmlPeserta = () => {
      jmlPeserta.value = 3;
    };
    const formData = reactive({
      jml_peserta: 5,
    });

    // diklatListStore.dataSourcePeringatanList.filter(null);
    return {
      formData,
      dukListStore,
      resetJmlPeserta,
      diklatListStore,
      pegawaiListStore,
      diklatListModel,
      commonStore,
      commonFunction,
    };
  },
  data() {
    return {
      logPopupRef: null,
      diklatTglTemp: null,
      allowAddingPegawai: false,
      isEditing: false,
      componentDiklat: null,
      rowIndexDiklat: null,
      pegawaiSource: null,
      pesertaDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      currentTgl: this.convertTglIndonesia(
        new Date().toISOString().slice(0, 10),
      ),
      pejabatMengetahui: null,
      pejabatMengetahuiJabatan: null,
      pejabatMembuatJabatan: null,

      serverUrl: `${BASE_URL}/`,
      fileUrl: null,

      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,
      filterOperations: ["=", "<>", ">", "<", "between"],
      loadingVisible: false,
      pejabat: null,
    };
  },

  async created() {
    //
    await this.commonStore.preloadStores();
    // const pegawais = await this.pegawaiListStore.getData(null);
    // this.pegawaiSource = pegawais.data;
  },

  async mounted() {
    this.diklatListStore.initialized;

    console.log("pejabat", this.pejabat);
    // await this.fetchDataPejabatPembuatGaji();
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    // onInitNewRowPegawai() {
    //   this.$nextTick(() => {
    //     this.$refs.dataGridPeserta.instance.editCell(0, "nama");
    //   });
    // },

    async reloadPegawai(tgl) {
      this.loadingVisible = true;
      try {
        const dataDuk = await this.dukListStore.getData([
          ["tgl", "=", tgl],
          ["capeg_tetap", "=", false],
          ["include_direksi", "=", true],
        ]);
        this.pegawaiSource = dataDuk.data;
        this.loadingVisible = false;
      } catch (error) {
        console.error("Error fetching dataDuk:", error);
        this.loadingVisible = false;
        notify("Error fetching data pegawai " + error, "error");
      }
    },
    async onTglValueChanged(e) {
      if (e.value) {
        this.diklatTglTemp = DateTime.fromJSDate(new Date(e.value)).toFormat(
          "yyyy-MM-dd",
        );
        this.allowAddingPegawai = true;
        await this.reloadPegawai(this.diklatTglTemp);
      } else {
        this.allowAddingPegawai = false;
        this.loadingVisible = false;
      }
    },
    calculateFilterExpressionBulan(
      filterValue,
      selectedFilterOperation,
      target,
    ) {
      var colFilter = "bulan";

      if (selectedFilterOperation === "=" && target == "filterBuilder") {
        return [
          [colFilter, ">=", filterValue],
          "and",
          [colFilter, "<=", this.commonFunction.endOfMonthDate(filterValue)],
        ];
      }

      if (selectedFilterOperation === "between" && target == "filterBuilder") {
        const minDate = filterValue[0];
        const maxDate = filterValue[1];
        if (
          minDate !== undefined &&
          maxDate !== undefined &&
          minDate !== null &&
          maxDate !== null
        ) {
          return [
            [colFilter, ">=", minDate], // Using '<' to include the exact date of birth
            "and",
            [colFilter, "<=", this.commonFunction.endOfMonthDate(maxDate)],
          ];
        } else if (
          minDate !== undefined &&
          minDate !== null &&
          minDate !== ""
        ) {
          //artinya mencari bulan awal aja
          return [
            [colFilter, ">=", minDate],
            "and",
            [colFilter, "<=", this.commonFunction.endOfMonthDate(minDate)],
          ];
        } else if (
          maxDate !== undefined &&
          maxDate !== null &&
          maxDate !== ""
        ) {
          //artinya mencari bulan akhir aja
          return [
            [colFilter, ">=", maxDate],
            "and",
            [colFilter, "<=", this.commonFunction.endOfMonthDate(maxDate)],
          ];
        } else {
          return null; // Return null to indicate that no filter should be applied
        }
      }

      if (selectedFilterOperation === "<" && target == "filterBuilder") {
        return [colFilter, "<", filterValue];
      }

      if (selectedFilterOperation === ">" && target == "filterBuilder") {
        return [
          colFilter,
          ">",
          this.commonFunction.endOfMonthDate(filterValue),
        ];
      }

      if (selectedFilterOperation === "<>" && target == "filterBuilder") {
        return [
          [colFilter, "<", filterValue],
          "or",
          [colFilter, ">", this.commonFunction.endOfMonthDate(filterValue)],
        ];
      }
    },

    onUpdatingDiklat(e) {
      if (this.pesertaDataSource._totalCount === 0) {
        e.cancel = true;
        notify("Peserta diklat tidak boleh kosong", "error");
        return;
      }

      this.pesertaDataSource
        .store()
        .load()
        .then((allData) => {
          // e.newData.diklat_pegawais = this.pesertaDataSource._items;
          e.newData.diklat_pegawais = allData;
        });

      e.newData.jml_peserta = this.pesertaDataSource._totalCount;
      e.newData.updated_by_user_id = auth.getUser().id; //diubah jika update or remove
    },
    onInitNewRow() {
      this.allowAddingPegawai = false;
      this.editing = false;
      this.pesertaDataSource.store().clear();
      this.formData.sertifikat = true;
    },
    async onInsertingDiklat(e) {
      if (this.pesertaDataSource._totalCount === 0) {
        e.cancel = true;
        notify("Peserta diklat tidak boleh kosong", "error");
        return;
      }

      this.pesertaDataSource
        .store()
        .load()
        .then((allData) => {
          // e.data.diklat_pegawais = this.pesertaDataSource._items;
          e.data.diklat_pegawais = allData;
        });

      // e.data.diklat_pegawais = this.pesertaDataSource._items;
      e.data.jml_peserta = this.pesertaDataSource._totalCount;
      e.data.created_by_user_id = auth.getUser().id; //diubah jika update or remove
    },
    onSavedPeserta() {
      // this.componentDiklat.cellValue(this.rowIndexDiklat, "jml_peserta", 9);
      const totalRows = this.$refs.dataGridPeserta.instance
        .getDataSource()
        .totalCount();

      if (this.isEditing) {
        this.componentDiklat.cellValue(
          this.rowIndexDiklat,
          "jml_peserta",
          totalRows,
        );
        this.componentDiklat.cellValue(
          this.rowIndexDiklat,
          "tgl",
          this.diklatTglTemp,
        );

        this.componentDiklat.cellValue(
          this.rowIndexDiklat,
          "dummy",
          "trigger update",
        );
      } else {
        this.componentDiklat.cellValue(
          this.rowIndexDiklat,
          "tgl",
          this.diklatTglTemp,
        ); //cobaaa
        this.componentDiklat.cellValue(
          this.rowIndexDiklat,
          "jml_peserta",
          totalRows,
        );
      }

      // if (this.$refs.formInstance) {
      //   alert("ada");
      //   const formInstance = this.$refs.formInstance;

      //   console.log("forminstance", formInstance);
      //   formInstance.updateData("jml_peserta", 1);
      // } else alert("tidak");

      // const cellValue = this.$refs.dataGrid.instance.cellValue(
      //   0,
      //   "jml_peserta"
      // );
      // console.log("debug cellValue", cellValue);
      // console.log("debug cellValue instance", this.$refs.dataGrid.instance);
      // console.log(
      //   "debug cellValue instance diklat ",
      //   this.componentDiklat.cellValue(this.rowIndexDiklat, "jml_peserta")
      // );
    },
    async onEditingStart(e) {
      // this.pesertaDataSource._items = e.data.diklat_pegawais;
      this.diklatTglTemp = e.data.tgl;
      this.isEditing = true;
      this.allowAddingPegawai = true;
      await this.reloadPegawai(e.data.tgl);
      this.pesertaDataSource.store().clear();

      e.data.diklat_pegawais.forEach((item) => {
        const mappedData = {
          pegawai_id: item.pegawai_id, // Map pegawai_id to peserta_id
          riwayat_pekerjaans_id: item.riwayat_pekerjaan_id, // Map riwayat_pekerjaan_id to pekerjaan_id
          nama: item.pegawai_id || "Unknown", // Handle optional fields
          jabatan_print: item.jabatan_print || "Unknown", // Handle optional fields
          nik: item.nik,
        };

        this.pesertaDataSource.store().insert(mappedData);
      });

      this.pesertaDataSource.reload().then(() => {
        if (this.$refs.dataGridPeserta)
          this.$refs.dataGridPeserta.instance.pageIndex(0);
      });
    },
    oneditorpreparing(e) {
      if (e.parentType === "dataRow") {
        if (e.class == "noteditable") e.editorOptions.disabled = true;
        if (e.dataField === "jml_peserta") {
          // e.editorOptions.value = 0; // Set default value when popup opens
          // e.editorOptions.value = this.formData.jml_peserta;
          this.componentDiklat = e.component;
          if (e.row) this.rowIndexDiklat = e.row.rowIndex;
        }
      }
      if (e.caption === "Bulan") {
        e.editorOptions.calendarOptions = {
          minZoomLevel: "year",
          maxZoomLevel: "year",
          displayFormat: "MM/yyyy",
          type: "month",
        };
      }

      if (e.caption === "Tahun") {
        e.editorOptions.calendarOptions = {
          minZoomLevel: "year",
          maxZoomLevel: "year",
          displayFormat: "yyyy",
          type: "year",
        };
      }

      if (e.caption === "Nama Pegawai") {
        e.editorOptions.onValueChanged = (args) => {
          const selectedPegawai = _.find(this.pegawaiSource, (item) => {
            return _.get(item, "id") === args.value;
          });
          if (selectedPegawai) {
            e.component.cellValue(
              e.row.rowIndex,
              "pegawai_id",
              selectedPegawai.id,
            );
            // e.component.cellValue(e.row.rowIndex, "nik", selectedPegawai.nik);
            e.component.cellValue(
              e.row.rowIndex,
              "jabatan_print",
              // selectedPegawai.jabatan_print
              selectedPegawai.riwayat_pekerjaans[0].jabatan_print,
            );
            e.component.cellValue(
              e.row.rowIndex,
              "riwayat_pekerjaans_id",
              // selectedPegawai.riwayat_pekerjaans_id
              selectedPegawai.riwayat_pekerjaans[0].id,
            );
            e.setValue(selectedPegawai.id);
            e.component.cellValue(e.row.rowIndex, "nama", selectedPegawai.id);
            // ✅ Save the data immediately (Enter simulation)
            e.component.saveEditData();
          }
        };
      }
    },

    setNamaPegawai(newValue, rowData) {
      const selectedPegawai = _.find(this.pegawaiSource, { id: newValue });
      if (selectedPegawai) {
        rowData.pegawai_id = selectedPegawai.id;
        rowData.nik = selectedPegawai.nik;
        rowData.jabatan_print = selectedPegawai.jabatan_print;
        return selectedPegawai.nama; // Ensure the correct value is set
      }
      return null; // Handle case when no selection is made
    },

    setCellValue(newData, value) {
      newData.nama = value;
    },

    allowUpdating() {
      if (this.can("pegawai-update")) return true; //adalah admin dan masuk status request payroll
      return false;
    },
    allowAdding() {
      if (this.can("pegawai-create")) return true; //adalah admin dan masuk status request payroll
      return false;
    },
    allowDeleting() {
      if (this.can("pegawai-del")) return true; //adalah admin dan masuk status request payroll
      return false;
    },

    async fetchDataPejabatPembuatGaji() {
      try {
        const data = {
          tgl_duk: DateTime.now().startOf("month").toISODate(),
        };

        const response = await axios.post(
          `${API_BASE_URL}/pejabat_gaji`,
          data,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          },
        );

        const kasubag = response.data.kasubagPersonalia;
        const kasubid = response.data.kasubidKepegawaian;
        if (kasubag) {
          this.pejabatMembuat = kasubag.nama;
          this.pejabatMembuatJabatan = "Kepala Sub Bagian Personalia";
        } else if (kasubid) {
          this.pejabatMembuat = kasubid.nama;
          this.pejabatMembuatJabatan = "Kepala Sub Bidang Kepegawaian";
        } else {
          this.pejabatMembuat = "Pejabat belum diupdate";
          this.pejabatMembuatJabatan = "Jabatan belum diupdate";
        }

        const kabag = response.data.kabagUmum;
        const kabid = response.data.kabidUmum;
        if (kabag) {
          this.pejabatMengetahui = kabag.nama;
          this.pejabatMengetahuiJabatan = "Kepala Bagian Umum";
        } else if (kabid) {
          this.pejabatMengetahui = kabid.nama;
          this.pejabatMengetahuiJabatan = "Kepala Bidang Umum";
        } else {
          this.pejabatMengetahui = "Pejabat belum diupdate";
          this.pejabatMengetahuiJabatan = "Jabatan belum diupdate";
        }

        // this.pejabatMengetahui =
        //   response.data.kabagUmum?.nama ||
        //   response.data.kabidUmum?.nama ||
        //   null;

        // this.pejabatMembuat =
        //   response.data.kasubagPersonalia?.nama ||
        //   response.data.kasubidKepegawaian?.nama ||
        //   null;

        console.log(response.data.kasubagPersonalia);

        console.log("pejabat mengetahui", this.pejabatMengetahui);
        console.log("pejabat membuat", this.pejabatMembuat);

        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    diklatFilteredDataBasedOnMonth(diklats) {
      const year = new Date(diklats[0].tgl).getFullYear();
      const months = Array.from(
        { length: 12 },
        (_, index) => `${year}-${String(index + 1).padStart(2, "0")}`,
      );

      const res = months
        .map((month) => ({
          month,
          ...this.getDiklatFiltered(month, diklats),
        }))
        .filter((data) => data.totalPegawais > 0);

      return res;
    },
    getDiklatFiltered(month, diklats) {
      const diklatPerMonth = _.filter(diklats, (item) =>
        _.startsWith(item.tgl, month),
      );
      const totalPegawais = _.sumBy(
        diklatPerMonth,
        (item) => item.diklat_pegawais.length,
      );
      return {
        totalPegawais,
        diklatPerMonth,
      };
    },

    addBulanCondition(filterValue) {
      if (!Array.isArray(filterValue)) return filterValue;

      // Check if filterValue is a simple condition (not nested)
      if (filterValue.length === 3 && filterValue[0] === "bulan") {
        // Get end of month date

        // Convert to nested structure and modify the second date
        if (filterValue[1] === "between") return filterValue;
        return [
          ["bulan", ">=", filterValue[2]], // Existing bulan condition
          "and",
          [
            "bulan",
            "<=",
            this.commonFunction.endOfMonthDate(filterValue[2], true),
          ], // Modified to end of month
        ];
      }

      // If filterValue is already an array of conditions, find the first 'bulan'
      const bulanConditionIndex = filterValue.findIndex(
        (item) => Array.isArray(item) && item[0] === "bulan",
      );

      if (bulanConditionIndex !== -1) {
        // Extract the existing "bulan" condition
        const bulanCondition = [...filterValue[bulanConditionIndex]];
        (bulanCondition[2] = this.commonFunction.endOfMonthDate(
          bulanCondition[2],
          true,
        )),
          // Insert the new "bulan" condition right after the first "bulan"
          filterValue.splice(bulanConditionIndex + 1, 0, "and", bulanCondition);
      }

      return filterValue;
    },

    printBpkp(gridRef) {
      // let filterValue = this.$refs[gridRef].instance.option("filterValue");
      let filterValue = this.$refs[gridRef].instance.getCombinedFilter();

      // if (filterValue && filterValue.length > 0) {
      //   const bulanFilter = filterValue.find((filter) => filter[0] === "bulan");
      //   console.log("bulanFilter", bulanFilter);
      //   if (bulanFilter) {
      //     const endOfMonthDate = this.commonFunction.endOfMonthDate(
      //       bulanFilter[2]
      //     );
      //     filterValue.push("and", ["bulan", "=", endOfMonthDate]);
      //   }
      // }

      const encodedFilter = encodeURIComponent(JSON.stringify(filterValue));
      // this.$router.push({
      //   name: "diklat-print",
      //   query: { filter: encodedFilter },
      // });
      const url = this.$router.resolve({
        name: "diklat-print-page-break",
        query: {
          filter: encodedFilter,
        },
      }).href;
      window.open(url, "_blank");
    },

    displayPenyesuaian(e) {
      if (e.data.status_penyesuaian) return "Penyesuaian";
      return "";
    },
    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },

    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },
    onContextMenuPreparing(e) {
      if (e.target == "content") {
        e.element.id = e.row.data.pegawai_id;

        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];
        e.items.push({
          text: "Lihat Detail Pegawai",
          icon: "user",
          onItemClick: () => {
            e.itemData = "Detail Pegawai";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Lihat Absensi",
          icon: "event",
          onItemClick: () => {
            e.itemData = "Absensi";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Riwayat Gaji",
          icon: "money",
          onItemClick: () => {
            e.itemData = "Riwayat Gaji";
            this.onItemClick(e);
          },
        });
      }
    },
    onItemClick(e) {
      let pegawaiId = e.element.id;

      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["absen_bulans_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
    },
    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,

    refreshDatagrid(gridRef) {
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Absen");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Diklat.xlsx",
          );
        });
      });
      e.cancel = true;
    },

    async exportBpkp(gridRef) {
      let filterValue = this.$refs[gridRef].instance.getCombinedFilter();
      const lastDate = _.chain([filterValue])
        .flattenDeep() // 1. Flatten all nested arrays
        .filter((val) => /^\d{4}-\d{2}-\d{2}/.test(val)) // 2. Keep only date strings
        .last() // 3. Get the very last one
        .value();

      const finalDate = _.defaultTo(
        lastDate,
        DateTime.now().startOf("month").toISODate(),
      );

      this.pejabat = await this.commonFunction.getPejabatPengesahan(finalDate);
      console.log("filterValue", filterValue);
      console.log("finalDate", finalDate);
      // return;

      const data = await this.diklatListStore.getData(filterValue);
      const diklats = data.data;
      const diklatFilteredDataBasedOnMonth =
        this.diklatFilteredDataBasedOnMonth(diklats);

      const diklatsSummary = data.summary;

      const workbook = XLSX.utils.book_new();
      const sheetName = "Data Diklat";
      XLSX.utils.book_append_sheet(workbook, {}, sheetName);
      let row = 1;
      let ws = workbook.Sheets[sheetName];
      ///////////////////////START TITLE
      this.wbAoa(
        ws,
        "DATA DIKLAT PEGAWAI TAHUN " + this.printTahun(diklats),
        "A" + row,
      );
      row += 2;
      this.wbAoa(ws, "No", "A" + row);
      this.wbAoa(ws, "Bulan", "B" + row);
      this.wbAoa(
        ws,
        "Penyelenggara Diklat/Narasumber Diklat (Lembaga)",
        "D" + row,
      );
      this.wbAoa(ws, "Jumlah Peserta", "E" + row);
      this.wbAoa(ws, "Nama Peserta", "G" + row);
      this.wbAoa(ws, "Jabatan", "H" + row);
      this.wbAoa(ws, "Ada atau Tidak Sertifikat", "I" + row);
      this.wbAoa(ws, "Biaya Diklat", "L" + row);
      this.wbAoa(ws, "Materi Diklat", "M" + row);
      row++;
      this.wbAoa(ws, "Ada", "I" + row);
      this.wbAoa(ws, "Tidak", "J" + row);
      row++;
      ///////////////////////END TITLE

      ///////////////////////START CONTENT

      let flagRowInitial = 0;
      diklatFilteredDataBasedOnMonth.forEach((month, indexMonth) => {
        row += 1;
        this.wbAoa(ws, indexMonth + 1, "A" + row);
        this.wbAoa(ws, this.printBulanNama(month.month), "B" + row);

        month.diklatPerMonth.forEach((diklat, indexDiklat) => {
          this.wbAoa(ws, indexDiklat + 1, "C" + row);
          this.wbAoa(ws, diklat.penyelenggara, "D" + row);
          this.wbAoa(ws, diklat.jml_peserta, "E" + row);
          flagRowInitial = row;
          diklat.diklat_pegawais.forEach((peserta, indexPeserta) => {
            this.wbAoa(ws, indexPeserta + 1, "F" + row);
            this.wbAoa(ws, peserta.pegawai.nama, "G" + row);
            this.wbAoa(ws, peserta.jabatan_print, "H" + row);

            row += 1;
          });
          row = flagRowInitial;
          this.wbAoa(ws, diklat.sertifikat ? "✔" : "", "I" + row);
          this.wbAoa(ws, diklat.sertifikat ? "" : "✔", "J" + row);
          this.wbAoa(ws, "Rp.", "K" + row);
          this.wbAoa(ws, this.formatNumber(diklat.biaya), "L" + row);
          this.wbAoa(ws, diklat.materi, "M" + row);
          row += diklat.jml_peserta;
        });
      });

      this.wbAoa(ws, "Total Jumlah", "A" + row);
      this.wbAoa(ws, "Rp.", "K" + row);
      this.wbAoa(ws, this.formatNumber(diklatsSummary[0]), "L" + row);

      row += 2;
      this.wbAoa(ws, "Singaraja, " + this.currentTgl, "L" + row);
      row += 1;
      this.wbAoa(ws, "Diperiksa Oleh: ", "D" + row);
      this.wbAoa(ws, "Dibuat Oleh: ", "L" + row);
      row += 3;
      this.wbAoa(ws, this.pejabat.pejabatMengetahui.nama, "D" + row);
      this.wbAoa(ws, this.pejabat.pejabatMembuat.nama, "L" + row);
      row += 1;
      // this.wbAoa(ws, "Ka.Bag. Umum ", "D" + row);
      // this.wbAoa(ws, "Ka.Sub. Bag. Personalia", "L" + row);

      this.wbAoa(ws, this.pejabat.pejabatMengetahui.jabatan, "D" + row);
      this.wbAoa(ws, this.pejabat.pejabatMembuat.jabatan, "L" + row);

      XLSX.writeFile(workbook, "Daftar Diklat.xlsx");

      // diklats.forEach((diklat, index) => {
      //   row += 1;
      //   this.wbAoa(ws, index + 1, "A" + row);
      //   this.wbAoa(ws, diklat.tgl, "B" + row);
      //   this.wbAoa(ws, diklat.tgl, "C" + row);
      //   this.wbAoa(ws, diklat.penyelenggara, "D" + row);
      //   this.wbAoa(ws, diklat.jml_peserta, "E" + row);
      //   this.wbAoa(ws, diklat.nama_peserta, "G" + row);
      //   this.wbAoa(ws, diklat.jabatan, "H" + row);
      //   this.wbAoa(ws, diklat.sertifikat ? "Ada" : "Tidak Ada", "I" + row);
      //   this.wbAoa(
      //     ws,
      //     this.commonFunction.formatNumberToCurrency(diklat.biaya),
      //     "L" + row
      //   );
      //   this.wbAoa(ws, diklat.materi, "M" + row);
      // });
    },

    printTahun(diklats) {
      if (diklats.length > 0) {
        return DateTime.fromFormat(diklats[0].tgl, "yyyy-M-dd").year;
      }
    },

    formatNumber(value) {
      // if (value) {
      //   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      // }
      // return value;
      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];

        // Add thousands separator
        return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },

    printBulanNama(tgl) {
      let date = DateTime.fromFormat(tgl, "yyyy-M-dd", { locale: "id" });
      if (!date.isValid) {
        date = DateTime.fromFormat(tgl, "yyyy-M", { locale: "id" });
      }
      if (date.isValid) {
        return date.setLocale("id").toFormat("MMMM");
      } else {
        return "";
      }
    },

    wbAoa(worksheet, text, cell) {
      XLSX.utils.sheet_add_aoa(worksheet, [[text]], {
        origin: cell,
      });
    },

    isDateFormatYMD(dateString) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // Regular expression for Y-m-d format
      return dateRegex.test(dateString);
    },

    convertTglIndonesia(inputDate) {
      if (!inputDate) return "";
      if (!this.isDateFormatYMD(inputDate)) return "";
      const parsedDate = DateTime.fromISO(inputDate);

      // Format the date in the desired Indonesian format
      const formattedDate = parsedDate.setLocale("id").toLocaleString({
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      return formattedDate;
    },
  },
};
</script>
